"use client";

import { c as _c } from "react/compiler-runtime";
import { chainSettings, type ChainType, fallbackChainId } from "@/constants/chain-specific";
import { baseUrl } from "@/constants/project-specific";
import useAppWallet from "@/hooks/useAppWallet";
import useAutoConnectWallet from "@/hooks/useAutoConnectWallet";
import { useDappscoutIframe } from "chewydapp-iframe";
import { AnimatePresence, motion } from "motion/react";
import { useCallback, useEffect, useState } from "react";
const IFRAME_SANDBOX_ATTRIBUTE = "allow-forms allow-orientation-lock " + "allow-pointer-lock allow-popups-to-escape-sandbox " + "allow-same-origin allow-scripts " + "allow-top-navigation-by-user-activation allow-popups allow-modals";
const IFRAME_ALLOW_ATTRIBUTE = "clipboard-read; clipboard-write;";
type Props = {
  isPending: boolean;
  appUrl: string;
  data?: undefined;
  chain?: ChainType;
};
export default function ExternalDapp(t0) {
  const $ = _c(15);
  const {
    appUrl,
    chain: t1
  } = t0;
  const chain = t1 === undefined ? fallbackChainId : t1;
  const {
    iframeRef,
    isReady
  } = useDappscoutIframe();
  useAutoConnectWallet();
  const [iframeKey, setIframeKey] = useState(0);
  const [isFrameLoading, setIsFrameLoading] = useState(true);
  useAppWallet(chain);
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setIframeKey(_temp);
    };
    t3 = [];
    $[0] = t2;
    $[1] = t3;
  } else {
    t2 = $[0];
    t3 = $[1];
  }
  useEffect(t2, t3);
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      setIsFrameLoading(false);
    };
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const handleIframeLoad = t4;
  let t5;
  let t6;
  if ($[3] !== appUrl || $[4] !== chain || $[5] !== iframeRef || $[6] !== isFrameLoading) {
    t5 = () => {
      if (!isFrameLoading) {
        const message = {
          blockscoutColorMode: "dark",
          blockscoutRootUrl: baseUrl,
          blockscoutAddressExplorerUrl: "https://shibariumscan.io/address/",
          blockscoutTransactionExplorerUrl: "https://shibariumscan.io/tx/",
          blockscoutNetworkName: chainSettings[chain].chainName,
          blockscoutNetworkId: Number(chain),
          blockscoutNetworkCurrency: chainSettings[chain].nativeCurrency.symbol,
          blockscoutNetworkRpc: chainSettings[chain].rpcUrls[0]
        };
        iframeRef?.current?.contentWindow?.postMessage(message, appUrl);
      }
    };
    t6 = [isFrameLoading, appUrl, iframeRef, chain];
    $[3] = appUrl;
    $[4] = chain;
    $[5] = iframeRef;
    $[6] = isFrameLoading;
    $[7] = t5;
    $[8] = t6;
  } else {
    t5 = $[7];
    t6 = $[8];
  }
  useEffect(t5, t6);
  let t7;
  if ($[9] !== appUrl || $[10] !== iframeKey || $[11] !== iframeRef || $[12] !== isFrameLoading || $[13] !== isReady) {
    t7 = <>{isReady ? <AnimatePresence><motion.iframe layout={true} initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          opacity: {
            ease: "anticipate",
            duration: 2
          },
          layout: {
            ease: "anticipate",
            duration: 0.1
          }
        }} exit={{
          opacity: 0
        }} key={iframeKey} allow={IFRAME_ALLOW_ATTRIBUTE} ref={iframeRef} sandbox={IFRAME_SANDBOX_ATTRIBUTE} height="100%" width="100%" className={isFrameLoading ? "none" : "flex-1 w-full h-[96vh] border-none"} src={decodeURIComponent(appUrl)} title="ChewySwap" onLoad={handleIframeLoad} /></AnimatePresence> : <AnimatePresence><motion.div layout={true} initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} className="flex justify-center align-middle content-center w-full h-svh"><img src="images/spinner.svg" width="150px" height="150px" className="justify-self-center" /></motion.div></AnimatePresence>}</>;
    $[9] = appUrl;
    $[10] = iframeKey;
    $[11] = iframeRef;
    $[12] = isFrameLoading;
    $[13] = isReady;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
}
function _temp(key) {
  return key + 1;
}